export const pagesProductPlanningCoreEn = {
  sidebar: {
    productRoadmapChange: 'Product Roadmap Change',
    productRoadmapDrafting: 'Product Roadmap Planning',
    underDevelopment: 'This operation package is currently under development.'
  }
};